function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M33.0907 27L13.5 7.40925C13.0714 7.00019 12.5017 6.77196 11.9092 6.77196C11.3168 6.77196 10.7471 7.00019 10.3185 7.40925L7.40924 10.3185C6.98798 10.7407 6.7514 11.3128 6.7514 11.9093C6.7514 12.5057 6.98798 13.0778 7.40924 13.5L26.9989 33.0907C27.4211 33.512 27.9932 33.7486 28.5896 33.7486C29.1861 33.7486 29.7581 33.512 30.1804 33.0907L33.0907 30.1815C33.5126 29.7596 33.7495 29.1874 33.7495 28.5907C33.7495 27.9941 33.5126 27.4219 33.0907 27ZM8.99999 11.9093L11.9092 9L17.5342 14.625L14.6239 17.5354L8.99887 11.9104L8.99999 11.9093Z",
  fill: "#F5F5F5"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M2.25 18L4.5 15.75L6.75 18L4.5 20.25L2.25 18Z",
  fill: "#F5F5F5"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M15.75 4.5L18 2.25L20.25 4.5L18 6.75L15.75 4.5Z",
  fill: "#F5F5F5"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M2.25 4.5L4.5 2.25L6.75 4.5L4.5 6.75L2.25 4.5Z",
  fill: "#F5F5F5"
});

function SvgFilter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/Filter.e88aa2b1.svg";
export { ForwardRef as ReactComponent };